import React from 'react';

/**
 * Render catalog text parts. A part may be plain, emphasized, or a link.
 */
export default function ContentParts({ parts, linkClassName }) {
  if (!Array.isArray(parts)) return parts ?? null;
  return parts.map((part, index) => {
    const key = `${index}-${part?.text || ''}`;
    if (part?.href) {
      return (
        <a
          key={key}
          href={part.href}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClassName}
          aria-label={part.aria_label || undefined}
        >
          {part.text}
        </a>
      );
    }
    if (part?.emphasis) return <strong key={key}>{part.text}</strong>;
    return <React.Fragment key={key}>{part?.text}</React.Fragment>;
  });
}
